import { CREDITS } from "@card-data/credits";
import { schemas } from "@card-data/generated/api.client";
import { REFERRALS } from "@card-data/referral-links";
import { CreditCardInput } from "@card-data/types";
import { WEIGHTS } from "@card-data/weights";

export const UNITED_CARDS: Array<CreditCardInput> = [
  {
    cardId: "8101f7827e3a1e797b09653f117b72d9",
    name: "United Business",
    issuer: schemas.IssuersEnum.enum.CHASE,
    network: schemas.NetworksEnum.enum.VISA,
    currency: schemas.CurrenciesEnum.enum.UNITED,
    isBusiness: true,
    annualFee: 150,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1,
    url: "https://www.theexplorercard.com/business-rewards-cards/business-card",
    imageUrl: "/images/chase/united-business.png",
    credits: [
      {
        value: 100,
        description: "Free Checked Bag",
        weight: 0.8,
      },
      {
        value: 100,
        description: "2x Lounge Pass",
        weight: WEIGHTS.LOUNGES_LIMITED_USE,
      },
      {
        value: 125,
        description: "United Credit",
        weight: 0.8,
      },
      {
        value: 100,
        description: "United Hotels",
        weight: 0.8,
      },
      {
        value: 100,
        description: "Rideshare",
        weight: 0.5,
      },
      {
        value: 120,
        description: "Instacard",
        weight: 0.5,
      },
      {
        value: 50,
        description: "Avis/Budget",
        weight: 0.5,
      },
    ],
    offers: [
      {
        amount: [{ amount: 110_000 }],
        spend: 5000,
        days: 90,
        credits: [],
        referralUrl: REFERRALS.CHASE.UNITED,
        details:
          "100k + 3k PQP after $5k/90d + 10k for adding authorized user.",
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 100_000 }],
        spend: 5000,
        days: 90,
        credits: [],
        expiration: "2026-06-15",
      },
      {
        amount: [{ amount: 125_000 }],
        spend: 5000,
        days: 90,
        credits: [],
        expiration: "2025-05-08",
      },
    ],
  },
  {
    cardId: "d2517ce6b72999e14f50c399347100ed",
    name: "United Club",
    issuer: schemas.IssuersEnum.enum.CHASE,
    network: schemas.NetworksEnum.enum.VISA,
    currency: schemas.CurrenciesEnum.enum.UNITED,
    isBusiness: false,
    annualFee: 695,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1,
    url: "https://www.theexplorercard.com/rewards-cards/club-card",
    imageUrl: "/images/chase/united-club-infinite.png",
    credits: [
      CREDITS.PRECHECK_OR_SIMILAR,
      {
        value: 150,
        description: "2x Checked Bags",
        weight: 0.75,
      },
      {
        value: 750,
        description: "United Lounge",
        weight: WEIGHTS.LOUNGES,
      },
      {
        value: 200,
        description: "United Hotels",
        weight: 0.75,
      },
      {
        value: 150,
        description: "Rideshare",
        weight: 0.5,
      },
      {
        value: 240,
        description: "Instacart",
        weight: 0.5,
      },
      {
        value: 100,
        description: "Avis/Budget",
        weight: 0.5,
      },
    ],
    offers: [
      {
        amount: [{ amount: 90_000 }],
        spend: 5000,
        days: 90,
        credits: [],
        referralUrl: REFERRALS.CHASE.UNITED,
        details: "80k after $5k/90d + 10k for adding authorized user.",
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 110_000 }],
        spend: 5000,
        days: 90,
        credits: [],
        expiration: "2026-05-20",
      },
      {
        amount: [{ amount: 90_000 }],
        spend: 5000,
        days: 90,
        credits: [],
        expiration: "2026-04-04",
      },
      {
        amount: [{ amount: 95_000 }],
        spend: 5000,
        days: 90,
        credits: [],
        expiration: "2025-05-08",
      },
    ],
  },
  {
    cardId: "80c6aca49a0e1442d51635c316f4a5ff",
    name: "United Club Business",
    issuer: schemas.IssuersEnum.enum.CHASE,
    network: schemas.NetworksEnum.enum.VISA,
    currency: schemas.CurrenciesEnum.enum.UNITED,
    isBusiness: true,
    annualFee: 695,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1,
    url: "https://www.theexplorercard.com/business-rewards-cards/club-card",
    imageUrl: "/images/chase/united-club-business.png",
    credits: [
      {
        value: 150,
        description: "2x Checked Bags",
        weight: 0.8,
      },
      {
        value: 125,
        description: "United Credit",
        weight: 0.8,
      },
      {
        value: 200,
        description: "United Hotels",
        weight: 0.8,
      },
      {
        value: 150,
        description: "Rideshare",
        weight: 0.5,
      },
      {
        value: 240,
        description: "Instacart",
        weight: 0.5,
      },
      {
        value: 100,
        description: "Avis/Budget",
        weight: 0.5,
      },
      {
        value: 750,
        description: "United Lounge",
        weight: WEIGHTS.LOUNGES,
      },
    ],
    offers: [
      {
        amount: [{ amount: 110_000 }],
        spend: 5000,
        days: 90,
        credits: [],
        referralUrl: REFERRALS.CHASE.UNITED,
        details:
          "100k + 2k PQP after $5k/90d + 10k for adding authorized user.",
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 100_000 }],
        spend: 5000,
        days: 90,
        credits: [],
        expiration: "2026-06-15",
      },
      {
        amount: [{ amount: 125_000 }],
        spend: 5000,
        days: 90,
        credits: [],
        expiration: "2025-05-08",
      },
    ],
  },
  {
    cardId: "85cd2b7d172e494eefad5b2ab012f21c",
    name: "United Explorer",
    issuer: schemas.IssuersEnum.enum.CHASE,
    network: schemas.NetworksEnum.enum.VISA,
    currency: schemas.CurrenciesEnum.enum.UNITED,
    isBusiness: false,
    annualFee: 150,
    isAnnualFeeWaived: true,
    universalCashbackPercent: 1,
    url: "https://www.theexplorercard.com/rewards-cards/explorer-card",
    imageUrl: "/images/chase/united-explorer.png",
    credits: [
      CREDITS.PRECHECK_OR_SIMILAR,
      {
        value: 100,
        description: "Free Checked Bag",
        weight: 0.8,
      },
      {
        value: 100,
        description: "2x Lounge Pass",
        weight: WEIGHTS.LOUNGES_LIMITED_USE,
      },
      {
        value: 60,
        description: "Rideshare Credits",
        weight: 0.5,
      },
      {
        value: 10_000,
        currency: schemas.CurrenciesEnum.enum.UNITED,
        description: "10k award flight discount",
        weight: 0.75,
      },
      {
        value: 100,
        currency: schemas.CurrenciesEnum.enum.USD,
        description: "United Travel",
        weight: 0.8,
      },
      {
        value: 100,
        currency: schemas.CurrenciesEnum.enum.USD,
        description: "United Hotels",
        weight: 0.5,
      },
      {
        value: 50,
        currency: schemas.CurrenciesEnum.enum.USD,
        description: "Avis/Budget",
        weight: 0.5,
      },
      {
        value: 120,
        currency: schemas.CurrenciesEnum.enum.USD,
        description: "Instacart+",
        weight: 0.4,
      },
    ],
    offers: [
      {
        amount: [{ amount: 25_000 }],
        spend: 3000,
        days: 90,
        credits: [
          {
            value: 500,
            description: "Statement Credit",
            weight: 1,
          },
        ],
        url: "https://secure.chase.com/web/oao/application/card?sourceCode=J4G6",
        details:
          "$500 statement credit after first purchase + 25k after $3k/90d; an additional 10k is available for adding an authorized user within 90 days.",
      },
      {
        amount: [{ amount: 75_000 }],
        spend: 3000,
        days: 90,
        credits: [],
        referralUrl: REFERRALS.CHASE.UNITED,
        details:
          "75k after $3k/90d + 10k for adding an authorized user. An additional 5k may be available with a United agent promotional code.",
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 35_000 }],
        spend: 3000,
        days: 90,
        credits: [
          {
            value: 500,
            description: "Statement Credit",
            weight: 1,
          },
        ],
        referralUrl: REFERRALS.CHASE.UNITED,
        details:
          "$500 statement credit after first purchase + 25k after $3k/90d + 10k for adding authorized user.",
        expiration: "2026-08-30",
      },
      {
        amount: [{ amount: 60_000 }],
        spend: 3000,
        days: 90,
        credits: [],
        details: "50k after $3k/90d + 10k for adding authorized user.",
        expiration: "2026-08-05",
      },
      {
        amount: [{ amount: 85_000 }],
        spend: 3000,
        days: 90,
        credits: [],
        expiration: "2026-06-15",
      },
      {
        amount: [{ amount: 70_000 }],
        spend: 3000,
        days: 90,
        credits: [],
        expiration: "2026-04-04",
      },
      {
        amount: [{ amount: 80_000 }],
        spend: 3000,
        days: 90,
        credits: [],
      },
    ],
  },
  {
    cardId: "4071699fe4b21cafb02cf8b2c9c57c86",
    name: "United Gateway",
    issuer: schemas.IssuersEnum.enum.CHASE,
    network: schemas.NetworksEnum.enum.VISA,
    currency: schemas.CurrenciesEnum.enum.UNITED,
    isBusiness: false,
    annualFee: 0,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1,
    url: "https://www.theexplorercard.com/rewards-cards/gateway-card",
    imageUrl: "/images/chase/united-gateway.png",
    credits: [],
    offers: [
      {
        amount: [{ amount: 30_000 }],
        spend: 1000,
        days: 90,
        credits: [],
        referralUrl: REFERRALS.CHASE.UNITED,
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 30_000 }],
        spend: 1000,
        days: 90,
        credits: [],
        expiration: "2024-07-01",
      },
    ],
  },
  {
    cardId: "34ab99720941eaa2a1671e5b3a996b19",
    name: "United Quest",
    issuer: schemas.IssuersEnum.enum.CHASE,
    network: schemas.NetworksEnum.enum.VISA,
    currency: schemas.CurrenciesEnum.enum.UNITED,
    isBusiness: false,
    annualFee: 350,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1,
    url: "https://www.theexplorercard.com/rewards-cards/quest-card",
    imageUrl: "/images/chase/united-quest.png",
    credits: [
      {
        value: 200,
        description: "United Credit",
        weight: 0.8,
      },
      {
        value: 150,
        description: "United Hotels",
        weight: 0.5,
      },
      {
        value: 100,
        description: "Rideshare",
        weight: 0.5,
      },
      {
        value: 180,
        description: "Instacart+",
        weight: 0.5,
      },
      {
        value: 80,
        description: "Avis/Budget",
        weight: 0.5,
      },
      {
        value: 10_000,
        currency: "UNITED",
        description: "10k award flight discount",
        weight: 0.8,
      },
      {
        value: 150,
        description: "2x Checked Bags",
        weight: 0.8,
      },
    ],
    offers: [
      {
        amount: [{ amount: 70_000 }],
        spend: 4000,
        days: 90,
        credits: [],
        referralUrl: REFERRALS.CHASE.UNITED,
        details:
          "60k + 500 PQP after $4k/90d + 10k for adding authorized user.",
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 80_000 }],
        spend: 4000,
        days: 90,
        credits: [],
        expiration: "2026-06-15",
      },
      {
        amount: [{ amount: 100_000 }],
        spend: 4000,
        days: 90,
        credits: [],
        expiration: "2026-05-20",
      },
      {
        amount: [{ amount: 80_000 }],
        spend: 4000,
        days: 90,
        credits: [],
        expiration: "2026-04-04",
      },
      {
        amount: [{ amount: 100_000 }],
        spend: 4000,
        credits: [],
        days: 90,
        expiration: "2025-07-31",
      },
    ],
  },
];
